import { render, staticRenderFns } from "./PopupPage.vue?vue&type=template&id=5a0d126a&scoped=true&"
import script from "./PopupPage.vue?vue&type=script&lang=ts&"
export * from "./PopupPage.vue?vue&type=script&lang=ts&"
import style0 from "./PopupPage.vue?vue&type=style&index=0&id=5a0d126a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d126a",
  null
  
)

export default component.exports